
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/medicaid-links-by-state",
      function () {
        return require("private-next-pages/resources/medicaid-links-by-state.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/medicaid-links-by-state"])
      });
    }
  